import { defineMessages } from "react-intl"

export enum CognitoError {
    CodeMismatchException = "CodeMismatchException",
    InvalidParameterException = "InvalidParameterException",
    LimitExceededException = "LimitExceededException",
    NotAuthorizedException = "NotAuthorizedException",
    UserNotConfirmedException = "UserNotConfirmedException",
    UserNotFoundException = "UserNotFoundException",
    UsernameExistsException = "UsernameExistsException",
}

export default defineMessages({
    [CognitoError.CodeMismatchException]: {
        id: "cognito.error.code.mismatch",
        defaultMessage: "Invalid verification code provided, please try again",
    },
    [CognitoError.InvalidParameterException]: {
        id: "cognito.error.invalid.param",
        defaultMessage:
            "Cannot reset password for the user as there is no registered/verified email",
    },
    [CognitoError.LimitExceededException]: {
        id: "cognito.error.limit.exceed",
        defaultMessage: "Attempt limit exceeded, please try after some time",
    },
    [CognitoError.NotAuthorizedException]: {
        id: "cognito.error.not.authoried",
        defaultMessage: "Incorrect username or password",
    },
    [CognitoError.UserNotConfirmedException]: {
        id: "cognito.error.not.confirmed",
        defaultMessage: "User is not confirmed",
    },
    [CognitoError.UsernameExistsException]: {
        id: "cognito.error.username.exist",
        defaultMessage: "The email already exists",
    },
    [CognitoError.UserNotFoundException]: {
        id: "cognito.error.user.not.found",
        defaultMessage: "Email does not exist",
    },
})
